/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ControlViolationsWithHighRiskLevelWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ControlViolationsWithHighRiskLevelWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ControlViolationsWithHighRiskLevelWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ControlViolationsWithHighRiskLevelWidgetConfiguration>): ControlViolationsWithHighRiskLevelWidgetConfiguration {
        let obj = Object.assign(new ControlViolationsWithHighRiskLevelWidgetConfiguration(), model);
        ControlViolationsWithHighRiskLevelWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ControlViolationsWithHighRiskLevelWidgetConfiguration>): ControlViolationsWithHighRiskLevelWidgetConfiguration {
        if (!model) return null;
        return ControlViolationsWithHighRiskLevelWidgetConfiguration.newInstance(<ControlViolationsWithHighRiskLevelWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ControlViolationsWithHighRiskLevelWidgetConfiguration) {
        if (!obj) return;

        models.ControlViolationsWithHighRiskLevelWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ControlViolationsWithHighRiskLevelWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ControlViolationsWithHighRiskLevelWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
